// Browser engines report a dropped or unreachable fetch as a TypeError whose
// message varies by engine, sometimes with the host appended in parentheses:
// WebKit "Load failed", Chromium "Failed to fetch" / "network error" (stream
// read), Firefox "NetworkError when attempting to fetch resource."
const NETWORK_ERROR_PATTERN =
  /^(load failed|failed to fetch|network ?error|the network connection was lost)/i

/**
 * True when a sync stream error means the connection dropped or the server was
 * unreachable, rather than the server rejecting the request. PowerSync retries
 * these on its own, and they are routine on patchy mobile coverage in the field,
 * where navigator.onLine stays true on a cellular link that passes no data.
 */
export function isTransientNetworkError(error: Error): boolean {
  return error.name === "TypeError" && NETWORK_ERROR_PATTERN.test(error.message)
}
